export const INDIA_COUNTRY_CODE = 'IN';
export const POPEYES_INDIA = 'https://www.popeyes.in';
